import { IS_EMPTY, IS_NOT_EMPTY, IS_NOT_ONE_OF, IS_ONE_OF } from '../filter-conditions.js';
export const hourFilterConditions = [
    IS_ONE_OF,
    IS_NOT_ONE_OF,
    IS_EMPTY,
    IS_NOT_EMPTY,
];
//# sourceMappingURL=filters.js.map